<template>
  <div class="flex flex-col">
    <h2>Contabilidad</h2>

    <div class="flex flex-col lg:flex-row gap-4 lg:gap-6 mt-6 items-start">
      <status-side-nav :options="sectionNavOptions" />

      <div class="flex-1 min-w-0 w-full">

    <router-view class="flex-auto overflow-auto min-h-screen" />
      </div>
    </div>
  </div>
</template>

<script>
import StatusSideNav from "@/components/ui/StatusSideNav";

export default {
  name: "Accounting",

  components: { StatusSideNav },

  computed: {
    sectionNavOptions() {
      return [
        {
          label: "Ingresos",
          icon: "💰",
          to: { name: "incomes" },
          active: ["incomesIndex", "incomesCreateForm", "incomesEditForm"].includes(this.$route.name),
          activeClass: "text-primary-500",
        },
        {
          label: "Egresos",
          icon: "💸",
          to: { name: "expenses" },
          active: ["expensesIndex", "expensesCreateForm", "expensesEditForm"].includes(this.$route.name),
          activeClass: "text-primary-500",
        },
      ];
    },
  },

  created() {
    this.$store.commit("setSelectedTab", "accounting");
  },

  methods: {},
};
</script>